<template>
  <detail-layout>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('tipos.metadata.pago') }}</label>
              <el-form-item prop="PaymentType">
                <el-select class="w-full" 
                  v-model="form.PaymentType" 
                  filterable
                  clearable :placeholder="$t('app.select')"
                  :disabled="isRoleUserOrConsulta">
                  <el-option
                    v-for="opt in formasDePago"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('agenda.account_type') }}</label>
              <el-form-item prop="AccountType">
                <el-select class="w-full" 
                  v-model="form.AccountType" 
                  filterable
                  clearable :placeholder="$t('app.select')"
                  :disabled="isRoleUserOrConsulta">
                  <el-option
                    v-for="opt in tiposCuenta"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isRequired" />{{ $t('invoices.invoices_issuing.iban') }}</label>
              <el-form-item prop="IBANAccountNumber">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.IBANAccountNumber"
                  maxlength='60'
                  :disabled="isRoleUserOrConsulta"
                />
              </el-form-item>
            </div>

            <div v-if="!isCreate">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.bank_code') }}</label>
              <el-form-item prop="BankCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.BankCode"
                  maxlength='60'
                  disabled
                />
              </el-form-item>
            </div>

            <div v-if="!isCreate">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.branch_code') }}</label>
              <el-form-item prop="BranchCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.BranchCode"
                  maxlength='60'
                  type="number"
                  disabled
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.bic_swift') }}</label>
              <el-form-item prop="BIC">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.BIC"
                  maxlength='60'
                  :disabled="isRoleUserOrConsulta"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.domiciliation_date') }}</label>
              <el-form-item prop="DomiciliationDate">
                <el-date-picker class="bg-white dark:bg-darkblue-900"
                  v-model="form.DomiciliationDate" type="date" :picker-options="dateRangeOptions"
                  :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="" :disabled="isRoleUserOrConsulta">
                </el-date-picker>
              </el-form-item>
            </div>

            <base-collapsible-form
              ref="baseCollapsibleAddressData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('address.header')}}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.location') }}</label>
                  <el-form-item prop="Address">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Address"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.codigo_postal') }}</label>
                  <el-form-item prop="PostCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.PostCode"
                      maxlength='10'
                      type="number"
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.poblacion') }}</label>
                  <el-form-item prop="Town">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Town"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.provincia') }}</label>
                  <el-form-item prop="Province">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Province"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.pais') }}</label>
                  <el-form-item prop="CountryCode">
                    <el-select class="w-full" 
                      v-model="form.CountryCode" 
                      filterable
                      clearable :placeholder="$t('app.select')"
                      :disabled="isRoleUserOrConsulta">
                      <el-option
                        v-for="opt in listPaises"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
  </detail-layout>
</template>

<script>

import { i18n } from '@/i18n'
import { IBAN as ibanRegex } from '@/utils/regex'

import DetailLayout from '@/components/layout/DetailLayout.vue'

import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'



function isValidIBAN (value) {
  return value.split(';').every(item => ibanRegex.test(item))
}

export default {
  name: 'detalle-bank-account',
  components: {
    DetailLayout,
  },
  props: {
    form: {
      type: Object,
    },
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      rules: {
        PaymentType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        AccountType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        IBANAccountNumber: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          },
          { required: true, validator: this.isIBANValid },
        ],
        Address: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        PostCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
        Town: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Province: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CountryCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
      },
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    }, 
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    isCreate: function () {
      return this.$route.params.idCuenta === -1
    },
    formasDePago: function () {
      return this.$store.getters['config/FORMAS_DE_PAGO']
    },
    tiposCuenta: function () {
      return this.$store.getters['config/TIPOS_CUENTA']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    isRequired: function () {
      return ['02', '04'].includes(this.form.PaymentType)
    }
  },
  mounted () {
    this.$refs.baseCollapsibleAddressData.toggle()
  },
  methods: {
    isIBANValid: function (rule, value, callback) {
      if (!value) {
        if (!this.isRequired) {
          callback()
        } else {
          callback(new Error(i18n.t('validation.complete')))
        }
      } else if (!isValidIBAN(value)) {
        callback(new Error(i18n.t('invoices.invoices_issuing.IBAN_regex')))
      } else if (value.length > this.maxLengthIBAN) {
        callback(new Error((i18n.t('validation.length_max', { maxLength: this.maxLengthIBAN }))))
      } else {
        callback()
      }
    },
    resetForm: function () {
      this.$refs.ruleForm.resetForm()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        callback(valid)
      })
    },
  },
}
</script>

<style>

</style>
